export enum ConfirmationDialogButtons {
    YesNo = 'yes-no',
    Ok = 'ok',
    YesNoBack = 'yes-no-back',
    OkLogin = 'ok-login',
    ConfirmCancel = 'confirm-cancel',
    OkLoginPricelist = 'ok-login-pricelist'
}